








































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import axios from 'axios'
import SnackbarService from '@/services/snackbar-service'
import AuthService from '@/services/auth-service'

@Component({
  components: {},
})
export default class SettingsUser extends Mixins(
  DexieService,
  SnackbarService,
  AuthService
) {
  newUserValue = ''
  newUserPassword = ''
  userToDelete: any = null
  userToEdit: any = null
  userToEditTmp: any = null
  dialogEditUsersIsOpen = false
  dialogEditUserIsOpen = false
  dialogDeleteUserIsOpen = false
  headers = [
    { text: 'Username', value: 'username' },
    { text: 'Read', value: 'active' },
    { text: 'Write', value: 'can_write' },
    { text: '', value: 'actions' },
  ]

  openDeleteDetailsDialog(user: any) {
    this.userToDelete = JSON.parse(JSON.stringify(user))
    this.dialogDeleteUserIsOpen = true
  }

  openEditDetailsDialog(user: any) {
    this.userToEdit = JSON.parse(JSON.stringify(user))
    this.userToEditTmp = JSON.parse(JSON.stringify(user))
    this.dialogEditUserIsOpen = true
  }

  postUser() {
    const payload = {
      username: this.newUserValue,
      can_write: true,
      password: this.newUserPassword,
      active: true
    }
    axios.post('users', payload).then((res: any) => {
      this.updateAccount()
      this.newUserValue = ''
      this.newUserPassword = ''
      this.notify({ text: 'Added successfully', type: 'success' })
    })
  }

  updateUser() {
    console.log('user to update', this.userToEdit)
    const payload = this.userToEdit
    axios.patch(`users/${this.userToEdit.id}`, payload).then((res: any) => {
      this.updateAccount()
      this.notify({ text: 'Updated successfully', type: 'success' })
      this.dialogEditUserIsOpen = false
    })
  }

  deleteUser() {
    axios.delete(`users/${this.userToDelete.id}`).then((res: any) => {
      this.updateAccount()
      this.notify({ text: 'Deleted successfully', type: 'success' })
      this.dialogDeleteUserIsOpen = false
    })
  }

  get userAlreadyExistsErrorAdd() {
    if (!this.$store.state.account || !this.newUserValue) {
      return false
    }
    return this.$store.state.account.users
      .map(i => i.username)
      .includes(this.newUserValue)
  }

  get userAlreadyExistsMessageAdd() {
    return this.userAlreadyExistsErrorAdd ? 'Already exists' : ''
  }

  get userAlreadyExistsErrorUpdate() {
    if (
      !this.$store.state.account ||
      !this.userToEdit ||
      this.userToEdit.username === ''
    ) {
      return false
    }
    console.log('returning includes')
    return this.$store.state.account.users
      .map(i => i.username)
      .filter(username => username !== this.userToEditTmp.username)
      .includes(this.userToEdit.username)
  }

  get userAlreadyExistsMessageUpdate() {
    return this.userAlreadyExistsErrorUpdate ? 'Already exists' : ''
  }

  @Watch('userToEdit.active')
  updateCanWrite() {
    if (!this.userToEdit.active) {
      console.log('active', this.userToEdit.active)
      this.$nextTick(() => {
        this.userToEdit.can_write = false
        console.log('can_write', this.userToEdit.can_write)
      })
    }
  }

  @Watch('userToEdit.can_write')
  updateCanRead() {
    if (this.userToEdit.can_write) {
      this.$nextTick(() => {
        this.userToEdit.active = true
      })
    }
  }
}
